import React, {useRef, useState, useImperativeHandle} from "react";
import {Button, Input, Modal, ModalBody, UncontrolledTooltip} from "reactstrap";
import {useNavigate} from "react-router-dom";
import throttle from "lodash/throttle";
import useBehaviourContext from "../../hooks/useBehaviourHook";
import useAppContext from "../../hooks/useAppHook";
import FilterPanel from "../core/Filters/FilterPanel";
import Select, {components} from "react-select";
import {CREATE_ALERT, GET_MY_ALERTS} from "../../graphql/ql/schema";
import {useMutation, useQuery} from "@apollo/client";
import {
    createAlert,
    createAlertVariables,
    getMyAlerts,
    getMyAlertsVariables
} from "../../graphql/ql/operation-result-types";
import Alert from './AlertModal';
import {toastService} from "../../services/toast.service";
import {pluck} from "../helper";


/* eslint-disable */
const SearchInput = React.forwardRef((props: any, ref) => {
    const {
        setShowSearchPanel,
        searchText,
        setSearchText,
        setMeetingSearchTerms,
        meetingSearchTerms,
        setHideContentPanel,
        setLoading,
        setCurrentLeftTab,
        setFilterTopNav,
        setExtraLeftPanel,
        setHideMeetingPanel,
        setTransSearchText
    } = useBehaviourContext();
    const {filterData, setFilterData, user, setSavedFilter} = useAppContext();
    const [isOpen, setIsOpen] = useState(false);
    const [savedState, setsavedState] = useState(null);
    const [openMsg, updateStatus] = useState(false);
    const textInput = useRef(null);
    const [filterForm, setFilterForm] = useState({});
    const toggle = () => setIsOpen(!isOpen);
    const [isFiltered, setIsFiltered] = useState(false);
    const [isEnableAlert, setIsEnableAlert] = useState(false);
    const [searchObject, setSearchObject] = useState<any>({});
    const history = useNavigate();


    const toggleAlertModal = (alertObject) => {
        setSearchObject(alertObject?.data ? alertObject.data : null);
        setIsEnableAlert(!isEnableAlert)
    };

    const {states = [], id = null} = user || {};

    const searchedStates = states
        ? states.filter((data) => data.type === "FILTER")
        : [];

    const {loading, error, data} = useQuery<getMyAlerts, getMyAlertsVariables>(GET_MY_ALERTS, {
        fetchPolicy: "network-only",
        variables: {userId: id}
    });

    const [createalert] = useMutation<createAlert, createAlertVariables>(
        CREATE_ALERT,
        {
            onCompleted(data: any): void {
                if (data != null) {
                    toastService.info("Alert successfully saved");
                }
            },
            onError(e: any): void {
                console.log(e);
                toastService.error("Error while saving alert settings");
            },
        }
    );

    const objectIds = data?.myAlerts && data.myAlerts.map(pluck("objectId"))

    const getEnableType = (objectId) => {
        const filteredAlert = data?.myAlerts && data.myAlerts.filter(alert => alert?.objectId && alert.objectId === objectId);
        return filteredAlert && filteredAlert.length && filteredAlert[0]?.triggerOn;
    }

    const constructedAlertData = searchedStates && searchedStates.reduce((acc: any, states) => {
        if (objectIds && objectIds.includes(states.id)) {
            const object = {
                ...states,
                isEnabled: (getEnableType(states.id) === 'Disabled') ? false : true,
                enableType: getEnableType(states.id),
                alertObject: data?.myAlerts && data.myAlerts.filter(alert => alert?.objectId && alert.objectId === states.id)[0]
            }
            acc.push(object);
        }
        return acc;
    }, []);

    const options = () =>
        constructedAlertData && constructedAlertData.map((searchData) => ({
            value: searchData?.data ? searchData.data : "",
            name: searchData.name,
            label: <>
                <span id="dditem" style={{paddingRight: "5px"}}>{searchData.name}</span>
                <UncontrolledTooltip placement="bottom" target="dditem">
                    Run Saved Search
                </UncontrolledTooltip>
            </>,
            isEnabled: searchData.isEnabled,
            enableType: searchData.enableType,
            alertObject: searchData.alertObject,
            id: searchData.id,
        }));


    const groupedOptions = [
        {
            label: "My Saved Searches",
            options: options()
        }
    ];
    const {Option} = components;
    const DropdownIndicator = (props) => {
        return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...props}>
                    <svg className="down-arrow-1"/>
                </components.DropdownIndicator>
            )
        );
    };
    const dot = () => ({
        alignItems: 'center',
        display: 'flex',
    });

    const customStyles = {
        dropdownIndicator: (base, state) => ({
            ...base,
            padding: '0 6px',
            transition: 'all .2s ease',
            transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
            color: 'var(--rf-text-tertiary, #9CA3AF)',
        }),
        input: styles => ({...styles, ...dot()}),
        placeholder: styles => ({...styles, ...dot(), color: 'var(--rf-text-secondary, #6B7280)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.04em'}),
        control: (styles, { isFocused }) => ({
            ...styles,
            boxShadow: 'none',
            borderRadius: 'var(--rf-radius-sm, 6px)',
            border: 'none',
            background: 'transparent',
            minHeight: '28px',
            fontSize: 11,
            cursor: 'pointer',
            '&:hover': {
                borderColor: 'transparent',
            }
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? 'var(--rf-primary-light, #EEF2FF)' : 'transparent',
            color: state.isFocused ? 'var(--rf-primary, #4F46E5)' : 'var(--rf-text-primary, #111827)',
            fontSize: '13px',
            padding: '8px 12px',
            borderRadius: '6px',
            cursor: 'pointer',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: 'var(--rf-radius-md, 12px)',
            border: '1px solid var(--rf-border, #E5E7EB)',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
            minWidth: '220px',
            zIndex: 20,
        }),
        menuList: (provided) => ({
            ...provided,
            padding: '4px',
        }),
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '11px',
            fontWeight: 600,
            color: 'var(--rf-text-tertiary, #9CA3AF)',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            padding: '8px 12px 4px',
        }),
        singleValue: (provided) => ({
            ...provided,
            fontSize: '11px',
            fontWeight: 600,
            color: 'var(--rf-text-primary, #111827)',
        }),
    };

    const IconOption = (props) => {
        return (<Option {...props}>
            {props.data.label}
            <span>
                <img
                    id="editAlert"
                    alt=""
                    onClick={() => toggleAlertModal(props)}
                    src={"../../assets/img/edit.svg"}
                    style={{
                        float: "right",
                        width: "18px",
                        height: "16px",
                        display: "block",
                        cursor: "pointer",
                        marginLeft: "10px"
                    }}
                />
                <UncontrolledTooltip placement="bottom-start"
                                     target="editAlert">Manage Saved Search & Alert</UncontrolledTooltip>
            </span>
            <span>
                <img
                    id="alertMsg"
                    alt=""
                    src={props.data.isEnabled ? "../../assets/img/alert_enabled.svg" : "../../assets/img/alert_disabled.svg"}
                    style={{
                        float: "right",
                        width: "18px",
                        height: "16px",
                        display: "block",
                        cursor: "auto",
                    }}
                />
            </span>

        </Option>)
    }

    const handleOnInputChange = (event) => {
        let meetings = [];
        if (event.keyCode === 13) {
            if (!event.target.value || event.target.value.length > 1) {
                setSearchText(event.target.value);
                if (true
                    //event.target.value ||
                    //(filterData instanceof Object && Object.keys(filterData).length)
                ) {
                    handleSearch(event.target.value);
                    setFilterTopNav(true);
                } else {
                    updateStatus(true);
                    setFilterTopNav(false);
                }
            }
        }
    };

    const handleSearch = throttle((val) => {
        setCurrentLeftTab("1");
        history(`/meetings`);
        setSearchText(val);
        setMeetingSearchTerms(
            meetingSearchTerms
                ? {...meetingSearchTerms, searchText: val}
                : {searchText: val}
        );
        setShowSearchPanel(val && val.length > 0);
        setExtraLeftPanel("");
        setHideMeetingPanel(true);
    }, 250);

    const clearSearch = () => {
        setSearchText("");
        if (textInput && textInput.current) {
            (textInput.current as any).value = "";
        }
        setsavedState(null);
        if (props.clearSearchCallBack) {
            props.clearSearchCallBack();
        }
    };
    useImperativeHandle(ref, () => ({
        clear: clearSearch
    }));

    const handleSearchSelection = (data) => {
        setsavedState(data);
        if (data.value) {
            const appliedFilters = JSON.parse(data.value);
            if (appliedFilters instanceof Object) {
                const {
                    searchText,
                    callType,
                    callScope,
                    callDisposition,
                    leadSource,
                    providers,
                    hostEmails,
                    teams,
                    dateMax,
                    dateMin,
                    hosts,
                    durationMax,
                    durationMin,
                    stageName,
                    crmFilter,
                    metricsFilter,
                    topics,
                } = appliedFilters;

                // Set savedFilter first to prevent default loading
                setSavedFilter(true);

                // Set search text and input value
                setSearchText(searchText || "");
                if (textInput && textInput.current) {
                    (textInput.current as any).value = searchText || "";
                }

                // Create the filter object with all fields
                const filters = {
                    callType: callType || null,
                    callScope: callScope || null,
                    callDisposition: callDisposition || null,
                    leadSource: leadSource || null,
                    providers: providers || null,
                    hostEmails: hostEmails || null,
                    teams: teams || null,
                    dateMax: dateMax || null,
                    dateMin: dateMin || null,
                    hosts: hosts && hosts.length ? hosts : null,
                    durationMax: durationMax || null,
                    durationMin: durationMin || null,
                    stageName: stageName || "",
                    topics: topics && topics.length ? topics : null,
                    metricsFilter: metricsFilter && Object.keys(metricsFilter).length ? metricsFilter : null,
                    crmFilter: crmFilter && Object.keys(crmFilter).length ? crmFilter : null,
                    searchText: searchText || "",
                    returnTranscripts: true,
                    weeklyCount: false,
                    fullList: true
                };

                // Update filter form to reflect saved search filters
                setFilterForm(filters);

                // Set meeting search terms
                setMeetingSearchTerms(filters);
                setFilterTopNav(true);
                setExtraLeftPanel("");
                setHideMeetingPanel(true);

                // Navigate to meetings dashboard to show filtered results
                history('/meetings');
            }
        }
    };

    function ModalFilter(props) {
        return (
            <FilterPanel
                isFiltered={isFiltered}
                setIsFiltered={setIsFiltered}
                isOpen={props.isOpen}
                toggle={props.toggle}
                filterForm={filterForm}
                setFilterForm={setFilterForm}
            />
        );
    }

    return (
        <>
            {isEnableAlert ? <Alert
                isOpen={isEnableAlert}
                toggle={toggleAlertModal}
                searchObject={searchObject}
                handleSearchSubmit={createalert}
                user={user}
            /> : null}
            <div className={isFiltered ? "activeSeachFilter nav-search" : "nav-search"}>
                <span className="rf-search-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="11" cy="11" r="8" />
                        <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                </span>
                <Input
                    type="search"
                    onKeyDown={handleOnInputChange}
                    onChange={(e) => {
                        // setSearchText(e.target.value);
                    }}
                    className="nav-search-input borderless"
                    style={{border:"none !important", flex: "1 1 auto"}}
                    innerRef={textInput}
                    placeholder="Search"
                ></Input>
                <button
                    className={isFiltered ? "rf-search-clear active" : "rf-search-clear"}
                    onClick={() => {
                        if (textInput && textInput.current) {
                            (textInput.current as any).value = "";
                        }
                        setSearchText("");
                        setFilterForm({});
                        setFilterData(filterData);
                        setMeetingSearchTerms(null);
                        setShowSearchPanel(false);
                        setIsFiltered(false);
                        setsavedState(null);
                        setHideMeetingPanel(false);
                        setTransSearchText("");
                        if (props.clearSearchCallBack) {
                            props.clearSearchCallBack();
                        }
                    }}
                    id="clearFilter"
                    data-tooltip="Clear all filters"
                    data-tooltip-position="right"
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
            </div>
            <FilterPanel
                isFiltered={isFiltered}
                setIsFiltered={setIsFiltered}
                isOpen={isOpen}
                toggle={toggle}
                filterForm={filterForm}
                setFilterForm={setFilterForm}
                clearSearch={clearSearch}
            />
            {openMsg ? (
                <Modal
                    size="sm"
                    centered={true}
                    isOpen={openMsg}
                    toggle={() => updateStatus(false)}
                    placement="center"
                >
                    <ModalBody className="modal-content-search">
                        <span style={{paddingBottom: 40}}>No Results Found</span>
                        <Button color="primary" onClick={() => updateStatus(false)}>
                            OK
                        </Button>
                    </ModalBody>
                </Modal>
            ) : null}
            <div className="nav-search-select">
                <Select
                    key={"select-topsearch"}
                    id="select-topsearch"
                    isMulti={false}
                    name="select-topsearch"
                    placeholder={
                        <span className="span-label" style={{marginTop: "-3px"}}>
                            Saved
                        </span>
                    }
                    className="nave-search-select"
                    classNamePrefix="nave-search-select"
                    components={{Option: IconOption, DropdownIndicator}}
                    options={groupedOptions}
                    styles={customStyles}
                    value={savedState}
                    onChange={(value) => handleSearchSelection(value)}
                />
            </div>
        </>
    );
});


// export const Search = withRouter<any, any>(SearchInput);
export const Search = SearchInput;